import { Divider, IconButton, TableCell, TableRow } from "@mui/material";
import { React } from "react";
import { pullDetails } from "../../../../../../utils/content";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { transactionStyle } from "./Dialog.styles";
import { ContentCopy } from "@mui/icons-material";
// import { transactionStyle } from "./transactionDialog";
const PullDetailDialog = (props) => {
  const { pull } = props;
  const customerStyle = {
    noBorder: {
      border: "none",
      padding: "10px",
    },
    card: {
      boxShadow:
        "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
      p: 2,
      borderRadius: "6px",
    },
  };

  return (
    <>
      <Divider sx={{ marginBottom: "14px" }} />
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.pullDetail,
          }}
        >
          Pull ID
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell
          sx={{ ...transactionStyle.noBorder, fontSize: 16, width: "68%" }}
        >
          {pull.pullId}
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "10%" }}>
          <IconButton
            onClick={() => navigator.clipboard.writeText(pull.pullId)}
          >
            <ContentCopy color="primary" />
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.pullDetail,
          }}
        >
          Carrier
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {pull?.carrier?.toUpperCase() || "N/A"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.pullDetail,
          }}
        >
          Policies
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {pull?.policies || "N/A"}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          sx={{
            ...transactionStyle.pullDetail,
          }}
        >
          Documents
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, width: "2%" }}>
          :
        </TableCell>
        <TableCell sx={{ ...transactionStyle.noBorder, fontSize: 16 }}>
          {pull?.documents || "N/A"}
        </TableCell>
      </TableRow>
    </>
  );
};

export default PullDetailDialog;
